module.exports = __webpack_public_path__ + "media/services.c8a21d1f.mp4";